/**
 * A function that adds scroll-active class to the body element after a certain trigger position 
 * 
 * @function
 * 
 * @param {string} body - A reference to the body element of the document
 * @param {number} triggerPosition - The point in pixels when the scroll-active class will be added to the body
 * 
 * @listens {scroll} - Listens for the scroll event on the window object
 * 
 * @returns {undefined} - Returns nothing
 */

(function(){
    var body = document.querySelector('body');

    var triggerPosition = 300; 

    window.addEventListener('scroll', window.groots.methods.debounce(function() {
        if (window.scrollY >= triggerPosition) {
            body.classList.add('scroll-active');
        } else {
            body.classList.remove('scroll-active');
        }

    }), 1000)


}(), window);